// Rechtstexte (Deutsch — für deutsche Launch-Seite üblich).
// Betreiberangaben bestätigt durch den Inhaber (20.09.2026).
// Keine Rechtsform, Handelsregisternummer oder USt-IdNr. vorhanden — bewusst
// neutral formuliert, nichts ergänzen ohne ausdrückliche Angabe.

export const legalContent = {
  impressum: {
    title: "Impressum",
    sections: [
      {
        heading: "Angaben gemäß § 5 DDG",
        paragraphs: [
          "Lidlink\nInhaber: Batur Okty\nGustav-Schatz-Hof 6\n24143 Kiel\nDeutschland",
        ],
      },
      {
        heading: "Kontakt",
        paragraphs: ["E-Mail: lidlink@outlook.de"],
      },
      {
        heading: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
        paragraphs: ["Batur Okty, Anschrift wie oben"],
      },
      {
        heading: "Streitbeilegung",
        paragraphs: [
          "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
        ],
      },
    ],
  },

  datenschutz: {
    title: "Datenschutzerklärung",
    sections: [
      {
        heading: "1. Verantwortlicher",
        paragraphs: [
          "Verantwortlich für die Datenverarbeitung auf dieser Website ist:\nLidlink, Inhaber: Batur Okty, Gustav-Schatz-Hof 6, 24143 Kiel, E-Mail: lidlink@outlook.de",
        ],
      },
      {
        heading: "2. Welche Daten wir verarbeiten",
        paragraphs: [
          "Geräteregistrierung (Teilnehmer): Name, E-Mail-Adresse, Hochschule, Studiengang, Semester, Gerätetyp und -modell, typische Nutzungsorte sowie freiwillig ausgeschlossene Kampagnenkategorien.",
          "Teilnehmerkonto: Zur Anmeldung wird ein Passwort verschlüsselt (als Hash) gespeichert; die E-Mail-Bestätigung erfolgt über einen einmaligen Link. Für die Launch-Aktion speichern wir zudem einen persönlichen Empfehlungscode, ggf. den Empfehlungscode der werbenden Person sowie den Status des Start- und Empfehlungsguthabens.",
          "Kampagnenanfragen (Unternehmen): Unternehmensname, Ansprechpartner, geschäftliche E-Mail-Adresse, gewünschtes Kontingent und Nachricht.",
          "Installationsnachweise: Fotos, die Teilnehmer zum Nachweis der Anbringung hochladen.",
          "Admin-Bereich: technisch notwendiges Login-Cookie (httpOnly) sowie fehlgeschlagene Anmeldeversuche (IP + E-Mail) zum Schutz vor Missbrauch.",
        ],
      },
      {
        heading: "3. Zwecke und Rechtsgrundlagen",
        paragraphs: [
          "Die Verarbeitung erfolgt zur Durchführung vorvertraglicher Maßnahmen und zur Erfüllung von Kampagnenvereinbarungen (Art. 6 Abs. 1 lit. b DSGVO), auf Grundlage unseres berechtigten Interesses am sicheren Betrieb der Plattform (Art. 6 Abs. 1 lit. f DSGVO) sowie — beim Upload von Installationsfotos — auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).",
        ],
      },
      {
        heading: "4. Speicherdauer",
        paragraphs: [
          "Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Registrierungen ohne Kampagnenzuteilung werden auf Anfrage gelöscht.",
        ],
      },
      {
        heading: "5. Weitergabe von Daten",
        paragraphs: [
          "Eine Weitergabe an Dritte erfolgt nur, soweit dies zur Kampagnendurchführung erforderlich ist (z. B. Versand von Kampagnenmaterialien) oder eine gesetzliche Pflicht besteht. Unternehmenskunden erhalten keine personenbezogenen Daten einzelner Teilnehmer, sondern aggregierte Kampagnenauswertungen.",
        ],
      },
      {
        heading: "6. Ihre Rechte",
        paragraphs: [
          "Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch (Art. 15–21 DSGVO). Erteilte Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft widerrufen. Zudem besteht ein Beschwerderecht bei der zuständigen Aufsichtsbehörde (für Schleswig-Holstein: ULD SH, Kiel).",
        ],
      },
      {
        heading: "7. Cookies und lokale Speicherung",
        id: "cookies",
        paragraphs: [
          "Diese Website verwendet ausschließlich technisch notwendige Speicherung: ein httpOnly-Cookie für den Admin-Login sowie die Spracheinstellung im lokalen Speicher (localStorage) Ihres Browsers.",
          "Es werden keine Tracking-, Marketing- oder Analyse-Cookies gesetzt. Da keine nicht-notwendigen Cookies verwendet werden, ist keine Einwilligung erforderlich; eine Auswahl entfällt daher.",
        ],
      },
      {
        heading: "8. Hosting",
        paragraphs: [
          "Diese Website wird bei einem externen Dienstleister gehostet. Der Hoster verarbeitet technische Zugriffsdaten (z. B. IP-Adresse, Zeitpunkt des Abrufs) in Server-Logdateien, die zur Sicherstellung des Betriebs erforderlich sind (Art. 6 Abs. 1 lit. f DSGVO).",
        ],
      },
    ],
  },

  agb: {
    title: "Allgemeine Geschäftsbedingungen (AGB)",
    sections: [
      {
        heading: "1. Geltungsbereich",
        paragraphs: [
          "Diese AGB gelten für die Nutzung der Plattform Lidlink durch registrierte Teilnehmer (nachfolgend „Teilnehmer“) und durch Unternehmen, die Kampagnen anfragen oder buchen (nachfolgend „Kunden“). Betreiber der Plattform ist Lidlink, Inhaber: Batur Okty, Gustav-Schatz-Hof 6, 24143 Kiel.",
        ],
      },
      {
        heading: "2. Leistungsbeschreibung",
        paragraphs: [
          "Lidlink vermittelt physische Werbekampagnen: Kunden buchen Werbeplatzierungen auf den Geräten (Laptops, Tablets) registrierter Teilnehmer. Lidlink produziert die Kampagnenfolien, koordiniert Versand, Verifikation und Reporting.",
        ],
      },
      {
        heading: "3. Registrierung der Teilnehmer",
        paragraphs: [
          "Die Registrierung ist kostenlos und unverbindlich. Eine Registrierung begründet keinen Anspruch auf Kampagnenzuteilung oder Vergütung. Die Angaben (insbesondere Hochschule, Studiengang, Gerät) müssen wahrheitsgemäß sein.",
        ],
      },
      {
        heading: "4. Kampagnenteilnahme",
        paragraphs: [
          "Teilnehmer werden zu passenden Kampagnen eingeladen und entscheiden frei über die Annahme. Vor Annahme werden Marke, Folien-Design, Laufzeit, Vergütung und Anforderungen offengelegt. Mit Annahme verpflichtet sich der Teilnehmer, die Folie für die vereinbarte Laufzeit sichtbar am Gerät anzubringen und einen fotografischen Installationsnachweis zu übermitteln.",
        ],
      },
      {
        heading: "5. Vergütung",
        paragraphs: [
          "Die Vergütung richtet sich nach Kampagne, Laufzeit und Gerät und wird vor Annahme transparent ausgewiesen. Die Auszahlung erfolgt nach erfolgreichem Abschluss der Kampagne, in der Regel nach bestätigter Verifikation und Ende der Laufzeit. Eine Registrierung ohne Kampagnenzuteilung wird nicht vergütet.",
        ],
      },
      {
        heading: "6. Startguthaben und Empfehlungsbonus (Launch-Aktion)",
        paragraphs: [
          "Im Rahmen der Launch-Aktion erhalten neue Teilnehmer nach einer vollständigen und gültigen Registrierung ein Startguthaben in Höhe von 5 € als Werbeguthaben (kein Bargeldanspruch).",
          "Das Guthaben ist nicht sofort auszahlbar. Es wird ausschließlich zusammen mit der ersten vom Teilnehmer erfolgreich abgeschlossenen, bezahlten Kampagne ausgezahlt. Eine Registrierung allein begründet keinen Zahlungsanspruch.",
          "Empfehlungsbonus: Werben registrierte Teilnehmer über ihren persönlichen Empfehlungslink 3 gültige neue Teilnehmer, erhalten sie einmalig einen zusätzlichen Empfehlungsbonus von 5 € Werbeguthaben (nicht 5 € pro geworbener Person). Auch dieser Bonus bleibt ausstehend und wird erst mit einer erfolgreich abgeschlossenen, bezahlten Kampagne ausgezahlt.",
          "Eine Empfehlung ist nur gültig, wenn die geworbene Person ein vollständiges Teilnehmerkonto anlegt, ihre E-Mail-Adresse bestätigt, ein gültiges Gerät (Laptop oder Tablet) registriert, kein bestehender Lidlink-Nutzer ist und es sich nicht um eine Doppel- oder Selbstregistrierung handelt. Jede geworbene Person zählt nur einmal.",
          "Gefälschte, doppelte oder manipulierte Registrierungen sowie Selbstempfehlungen begründen keinen Anspruch auf Guthaben. Lidlink ist berechtigt, betrügerische oder ungültige Registrierungen zu entwerten und entsprechendes Guthaben zu stornieren.",
          "Ausstehendes Werbeguthaben stellt keine bereits für die Registrierung geschuldete Geldforderung dar. Eine Registrierung garantiert weder die Verfügbarkeit noch die Zuteilung einer Kampagne.",
        ],
      },
      {
        heading: "7. Folien und Gerätesicherheit",
        paragraphs: [
          "Lidlink verwendet hochwertige, rückstandsfrei entfernbare Spezialfolien. Die Anbringung und Entfernung erfolgt nach Anleitung und auf eigene Sorgfalt des Teilnehmers. Für Schäden durch unsachgemäße Anbringung oder Verwendung fremder Materialien wird nicht gehaftet.",
        ],
      },
      {
        heading: "8. Kampagnenanfragen von Kunden",
        paragraphs: [
          "Kampagnenanfragen über die Website sind unverbindlich. Ein Vertrag kommt erst durch schriftliche Bestätigung der Kampagne durch Lidlink zustande. Auf der Website werden keine Preise ausgewiesen; Kunden erhalten ein individuelles Angebot.",
        ],
      },
      {
        heading: "9. Haftung",
        paragraphs: [
          "Lidlink haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit. Bei leichter Fahrlässigkeit haftet Lidlink nur bei Verletzung wesentlicher Vertragspflichten, der Höhe nach begrenzt auf den vorhersehbaren, vertragstypischen Schaden.",
        ],
      },
      {
        heading: "10. Schlussbestimmungen",
        paragraphs: [
          "Es gilt deutsches Recht. Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
        ],
      },
    ],
  },
};

export const legalDisclaimer = "Stand: September 2026";
